<ng-container *ngFor="let component of components">
  <div>
    <ng-template #dynamic> </ng-template>
  </div>
</ng-container>
